import {marketMovers, MarketMovers} from "./gainers-losers/MarketMoversComponent";
import {marketMoversGrid, MarketMoversGrid} from "./grid/MarketMoversGridComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.components`;

    return angular.module(moduleName, [])
                  .component(MarketMovers, marketMovers())
                  .component(MarketMoversGrid, marketMoversGrid())
                  .name;
}
